import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useFieldglassShiftIssuesContextValue } from '../context/FieldglassShiftIssuesProvider'

export const FieldglassShiftIssuesHeader = () => {
  const { state, actions } = useFieldglassShiftIssuesContextValue()

  return (
    <Header
      title="Fieldglass Shift Issues"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
